/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken, prettyHour } from '../utils/util';
import './City.css';
import Wrapper from './Wrapper';
import {
  getCityInfo,
} from '../actions';
import EscapeForm from './partials/EscapeForm';


class TimeSlot extends Component {
  render() {
    let timeSlot = this.props.timeSlot;
    return (
      <div className={cx('TimeSlot', timeSlot.status)}>
        <div className="time">{prettyHour(timeSlot.datetime)}</div>
        <div className="status">{timeSlot.status}</div>
      </div>
    );
  }
}


class Room extends Component {
  render() {
    let room = this.props.room;

    let nodes = this.props.timeSlots.map(timeSlot => <TimeSlot timeSlot={timeSlot} />);

    let more;
    if (nodes.length) {
      more = 'More';
    } else {
      more = '';
    }

    let url = '/s?city=' + encodeURIComponent(room.location.city.fullName) + '&room=' + room.name;

    return (
      <div className="Room">
        <div className="info">
          <div className="room-name"><Link to={'/r/' + room.prettySlug + '/' + room.id}>{room.name}</Link></div>
          <div className="address">{room.location.address}</div>
          <div className="num-players">
            {room.minPeople}-{room.maxPeople} players,{' '}
            {room.minutes} minutes,{' '}
            {room.location.company}
          </div>
          <div className="description">{room.description}</div>
          {room.img && <div className="image"><img src={room.img} /></div>}
        </div>

        <div className="times">
          <div>{nodes}</div>
          <div className="buttons">
            <Link to={url}><Button>See {more} Available Times</Button></Link>
          </div>
        </div>
      </div>
    );
  }
}


class City extends OzComponent {

  static need = [
    ['cityInfo', getCityInfo, p => p.slug],
  ];

  state = {};

  renderSummary() {
    let cityInfo = this.props.cityInfo;
    if (!cityInfo) return null;

    let count = cityInfo.rooms.length;

    return (
      <div className="summary">
        There are {count} escape room{count == 1 ? '' : 's'} near {cityInfo.city.fullName}.
      </div>
    );
  }

  renderRooms() {
    let cityInfo = this.props.cityInfo;
    if (!cityInfo) return null;

    let timeSlotsByRoom = {};
    for (let timeSlot of cityInfo.timeSlots) {
      if (!timeSlotsByRoom[timeSlot.room]) {
        timeSlotsByRoom[timeSlot.room] = [];
      }
      timeSlotsByRoom[timeSlot.room].push(timeSlot);
    }

    let roomsByCompany = {};
    for (let room of cityInfo.rooms) {
      let company = room.location ? room.location.company  : '';
      if (!roomsByCompany[company]) {
        roomsByCompany[company] = [];
      }
      roomsByCompany[company].push(room);
    }

    let companies = Object.keys(roomsByCompany);
    companies.sort();
    let nodes = [];

    console.log('COMPANIES', companies);

    for (let company of companies) {
      let companyNodes = []
      for (let room of roomsByCompany[company]) {
        let node = (
          <div key={room.id}>
            <Room room={room} timeSlots={timeSlotsByRoom[room.id] || []} />
          </div>
        );
        companyNodes.push(node);
      }
      let node = (
        <div className="company">
          <div className="company-name">{company}</div>
          <div className="company-rooms">{companyNodes}</div>
        </div>
      );
      nodes.push(node);
    }

    return <div className="rooms">{nodes}</div>;
  }

  render() {
    let city = this.props.cityInfo ? this.props.cityInfo.city : null;

    return (
      <Wrapper className="City" title={city ? 'Escape Rooms in ' + city.fullName : ''}>
        {this.renderSummary()}
        {this.renderRooms()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    cityInfo: state.get.cityInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(City);



/** WEBPACK FOOTER **
 ** ./src/components/City.js
 **/